import { hideChat, setZendeskLoaded, showChat } from "@/store/zendeskNotificationSlice";
import { dispatchZendeskLoadEvent } from "@/utils/analyticsEventSender";
import { UnknownAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";

const openZendeskMessenger = (showChatCallback?: () => void): void => {
  try {
    window.zE?.("messenger", "show");
    setTimeout(() => {
      window.zE?.("messenger", "open");
      // Update chat status and hide notification
      showChatCallback?.();
    }, 100);
  } catch (err) {
    console.error("Error opening Zendesk chat:", err);
  }
};

export const loadZendesk = (dispatch: Dispatch<UnknownAction>, openChat?: boolean): Promise<void> => {
  const onZendeskLoaded = () => dispatch(setZendeskLoaded());
  const onOpenHandler = () => dispatch(showChat());
  const onCloseHandler = () => {
    dispatch(hideChat());
    window.zE?.("messenger", "hide");
  };

  // Check if Zendesk is already loaded
  if (typeof window.zE === "function") {
    onZendeskLoaded();
    if (openChat) openZendeskMessenger(onOpenHandler);
    return Promise.resolve();
  }

  // Zendesk not loaded, trigger GTM event to load it
  // Set up open and close handlers only when the Zendesk widget is first loaded
  dispatchZendeskLoadEvent(onOpenHandler, onCloseHandler);

  // Wait for Zendesk to load and open chat
  return new Promise<void>((resolve) => {
    let attempts = 0;
    const maxAttempts = 200; // 10 seconds (200 * 50ms)
    const interval = setInterval(() => {
      attempts++;
      if (typeof window.zE === "function") {
        clearInterval(interval);
        onZendeskLoaded();
        resolve();
        if (openChat) openZendeskMessenger(onOpenHandler);
      } else if (attempts >= maxAttempts) {
        console.warn("⚠️ Zendesk not loaded after 10 seconds");
        clearInterval(interval);
        resolve();
      }
    }, 50);
  });
};
